/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Return Model of Access Restriction
 */
export interface AccessRestrictionsAccessRestrictionModel {
  id?: string;
  accessTypes?: Array<AccessRestrictionsAccessRestrictionModelAccessTypesEnum> | null;
  operationTypes?: Array<AccessRestrictionsAccessRestrictionModelOperationTypesEnum> | null;
  isAdminRestriction?: boolean;
}
export enum AccessRestrictionsAccessRestrictionModelAccessTypesEnum {
  System = 'System',
  Admin = 'Admin',
  User = 'User'
}
export enum AccessRestrictionsAccessRestrictionModelOperationTypesEnum {
  Read = 'Read',
  Write = 'Write'
}
